import './styles.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/tabulator-tables/dist/css/tabulator_bootstrap5.min.css';

import { CellComponent, ColumnComponent, ColumnDefinition, EditModule, Filter, FilterModule, FormatModule, InteractionModule, PopupModule, ResizeColumnsModule, ResizeTableModule, ResponsiveLayoutModule, RowComponent, SortDirection, Sorter, SortModule, Tabulator, TooltipModule } from 'tabulator-tables';

type logoDataType = {
	logohandle: string;
	title: string;
	sort: string;
	website: string;
	wikipedia?: string;
	images?: string[];
};

const dataUrl = "https://www.vectorlogo.zone/api/rawdata.json";
const windowTarget = "_self";

function makeImageFormatFn(imgType:string) {
	return function (cell: CellComponent) {
		var data = cell.getRow().getData() as logoDataType;


		const images = data.images;
		if (images && images.length > 0) {
			const target = `${data.logohandle}-${imgType}.svg`;
			const imgUrl = images.find(img => img == target);
			if (imgUrl) {
				const el = document.createElement("img");
				el.src = `https://www.vectorlogo.zone/logos/${data.logohandle}/${imgUrl}`;
				el.style.maxHeight = "1.5em";
				el.style.maxWidth = "100%";
				el.style.cursor = "pointer";
				return el;
			}
		}

		return "";
	}
}

function makeImageFilterFn(imgType:string) {
	return function (headerValue: boolean, rowValue: any, rowData:any, filterParams:any) {

		var data = rowData as logoDataType;


		const images = data.images;
		if (!images || images.length === 0) {
			return headerValue === false;
		}
		const target = `${data.logohandle}-${imgType}.svg`;
		const imgUrl = images.find(img => img == target);

		return !!imgUrl === headerValue;
	}
}

function makeImageClickFn(imgType:string) {

	return function (e: UIEvent, cell: CellComponent) {

		var data = cell.getRow().getData() as logoDataType;


		const images = data.images;
		if (!images || images.length === 0) {
			return;
		}
		const target = `${data.logohandle}-${imgType}.svg`;
		const imgUrl = images.find(img => img == target);
		if (!imgUrl) {
			return;
		}
		const height = imgType == 'ar21' ? 60 : 64;
		const width = imgType == 'ar21' ? 120 : 64;
		const backUrl = encodeURIComponent(window.location.href);
		const zoom = imgType == 'ar21' ? '4' : 'icons';

		const url = `https://svg-viewer.fileformat.info/view.html?url=https://www.vectorlogo.zone/logos/${data.logohandle}/${data.logohandle}-${imgType}.svg&height=${height}&width=${width}&zoom=${zoom}&backUrl=${backUrl}`;
		window.open(url, windowTarget)?.focus();
	}
}

function titleFilter(headerValue: string, rowValue: any, rowData:any, filterParams:any) {
	var data = rowData as logoDataType;

	if (headerValue.startsWith("/") && headerValue.endsWith("/")) {
		const regexStr = headerValue.substring(1, headerValue.length - 1);
		try {
			const regex = new RegExp(regexStr, "i");
			return regex.test(data.title);
		} catch (error) {
			console.log(`Invalid regex: ${regexStr}`);
			return false;
		}
	}

	return data.title.toLowerCase().startsWith(headerValue.toLowerCase());
}
function titleSort(a:string, b:string, aRow:RowComponent, bRow:RowComponent, column:ColumnComponent, dir:SortDirection, sorterParams:{}){
	var aData = aRow.getData() as logoDataType;
	var bData = bRow.getData() as logoDataType;

	return aData.sort.localeCompare(bData.sort);
}

function buildActionLink(url:string, img: string, title: string) {

	const el = document.createElement("a");
	el.href = url;
	el.target = windowTarget;
	el.title = title;

	const imgEl = document.createElement("img");
	imgEl.src = `/images/actions/${img}.svg`;
	imgEl.style.width = "1.5em";
	imgEl.style.paddingRight = "0.25em";
	el.appendChild(imgEl);

	return el;
}


function actionFormatter(cell: CellComponent) {
	var data = cell.getRow().getData() as logoDataType;

	const actions = document.createElement("span");

	actions.appendChild(buildActionLink(`https://logosear.ch/search.html?q=${encodeURIComponent(data.title)}`, 'search', `Search on LogoSearch`));
	if (data.wikipedia) {
		actions.appendChild(buildActionLink(data.wikipedia, 'wikipedia', `Wikipedia for ${data.title}`));
	} else {
		actions.appendChild(buildActionLink(`https://en.wikipedia.org/wiki/Special:Search?search=${encodeURIComponent(data.title)}`, 'wikipedia', `Search Wikipedia for ${data.title}`));
	}
	actions.appendChild(buildActionLink(`https://github.com/VectorLogoZone/vectorlogozone/tree/main/src/content/logos/${data.logohandle}`, 'source', `Source location for ${data.title} logos`));
	actions.appendChild(buildActionLink(data.website, 'link', `Website for ${data.title}`));
	actions.appendChild(buildActionLink(`https://upload.vectorlogo.zone/logos/${data.logohandle}/index.html`, 'upload', `Upload new logos for ${data.title}`));

	return actions;
}

/*
function saveScrollPosition(table: Tabulator, top: number) {
	var qs = new URLSearchParams(window.location.search);
	if (top === 0) {
		qs.delete("scroll");
	} else {
		var rows = table.rowManager.getVisibleRows(null, true);
		qs.set("scroll", rows[0].getData().logohandle);
	}
	window.history.replaceState(null, "", "?" + qs);
}

function clearScrollPosition(table: Tabulator, top: number) {
	var qs = new URLSearchParams(window.location.search);
	qs.delete("scroll");
	window.history.replaceState(null, "", "?" + qs);
}
*/

function showError(msg: string) {
	console.log(`ERROR: ${msg}`);
	document.getElementById('loading')!.classList.add('d-none');
	document.getElementById('errdiv')!.classList.remove('d-none');
	document.getElementById('errmsg')!.innerHTML = msg;
}

async function main() {

	let rawData: any;
	try {
		const resp = await fetch(dataUrl, {
			method: 'GET',
			redirect: 'follow',
		});
		if (!resp.ok) {
			showError(`HTTP Error fetching data: ${resp.status} ${resp.statusText}`);
			return;
		}
		const jsonData = await resp.json();
		rawData = jsonData.data;
	} catch (error) {
		showError(`Error fetching data: ${error}`);
		return;
	}

	const data: logoDataType[] = rawData as logoDataType[];


	const qs = new URLSearchParams(window.location.search);
	const initialSort: Sorter[] = [{ column: "title", dir: "asc" }];
	const filters: Filter[] = [];
	if (qs) {
		for (const [key, value] of qs.entries()) {
			if (key == "sort") {
				initialSort[0].column = value;
				continue;
			}
			if (key == "dir") {
				initialSort[0].dir = value == "desc" ? "desc" : "asc";
				continue;
			}
			if (key && value) {
				filters.push({ field: key, type: "=", value: value });
			}
		}
	}


	Tabulator.registerModule([EditModule, FilterModule, FormatModule, InteractionModule, PopupModule, ResizeColumnsModule, ResizeTableModule, ResponsiveLayoutModule, SortModule, TooltipModule]);

	const table = new Tabulator('#achtable', {
		autoResize: true,
		data,
		columns: [
			{
				cellClick: makeImageClickFn('ar21'),
				field: 'ar21',
				formatter: makeImageFormatFn('ar21'),
				hozAlign: "center",
				headerFilter: "tickCross",
				headerFilterFunc: makeImageFilterFn('ar21'),
				headerFilterParams: { tristate: true },
				headerHozAlign: "center",
				headerSort: false,
				responsive: 2,
				title: "2:1",
				width: 100
			},
			{
				cellClick: makeImageClickFn('icon'),
				field: 'icon',
				formatter: makeImageFormatFn('icon'),
				hozAlign: "center",
				headerFilter: "tickCross",
				headerFilterFunc: makeImageFilterFn('icon'),
				headerFilterParams: { tristate: true },
				headerHozAlign: "center",
				headerSort: false,
				responsive: 2,
				title: "Icon",
				width: 100
			},
			{
				title: 'Name',
				field: 'title',
				formatter: "link",
				formatterParams: {
					labelField: "title",
					url: (cell) => `https://www.vectorlogo.zone/logos/${cell.getRow().getData().logohandle}/`,
					target: windowTarget,
				},
				headerFilter: "input",
				headerFilterFunc: titleFilter,
				headerPopup: `Use <code>/regex/</code> to search with a regular expression`,
				headerPopupIcon: '<span class="badge rounded-pill text-bg-primary">?</span>',
				responsive: 0,
				sorter: titleSort,
				widthGrow: 99,
			},
			{
				title: '',
				field: 'logohandle',
				formatter: actionFormatter,
				headerSort: false,
				responsive: 1,
				width: 150,
			},
		],
		height: "100%",
		index: "logohandle",
		initialHeaderFilter: filters,
		initialSort,
		layout: "fitColumns",
		placeholder: "No matches",
		responsiveLayout: "hide",
		footerElement: `<span class="w-100 mx-2 my-1">
				<a href="https://www.vectorlogo.zone/"><img src="https://www.vectorlogo.zone/favicon.svg" class="pe-2" style="height:1.2em;" alt="VLZ logo"/>VectorLogo.Zone</a>
				<span id="rowcount" class="px-3">Rows: ${data.length.toLocaleString()}</span>
				<a class="d-none d-lg-block float-end" href="https://upload.vectorlogo.zone/reports/index.html"><img src="/favicon.svg" class="pe-2" style="height:1.2em;" alt="VLZ logo"/>VLZ Reports</a>
			</span>`,
	});

	/*
	table.on("scrollVertical", function (top) {
		clearScrollPosition(table, top);
	});
	*/

	table.on("dataFiltered", function (filters, rows) {
		var el = document.getElementById("rowcount");
		var qs = new URLSearchParams(window.location.search);
		for (const col of table.getColumns()) {
			qs.delete(col.getField());
		}
		if (filters && filters.length > 0) {
			el!.innerHTML = `Rows: ${rows.length.toLocaleString()} of ${data.length.toLocaleString()}`;
			for (const f of filters) {
				qs.set(f.field, f.value as string);
			}
		} else {
			el!.innerHTML = `Rows: ${data.length.toLocaleString()}`;
		}
		window.history.replaceState(null, "", "?" + qs);
	});

	table.on("dataSorted", function (sorters, rows) {
		var qs = new URLSearchParams(window.location.search);
		var sortCol = sorters[0]?.column.getField();
		var sortDir = sorters[0]?.dir;
		if (sortCol != "title") {
			qs.set("sort", sortCol);
		} else {
			qs.delete("sort");
		}
		if (sortDir != "asc") {
			qs.set("dir", sortDir);
		} else {
			qs.delete("dir");
		}
		if (qs.toString() == "") {
			window.history.replaceState(null, "", window.location.pathname);
		} else {
			window.history.replaceState(null, "", "?" + qs);
		}
	});

	/*
	table.on("tableBuilt", function () {
		var qs = new URLSearchParams(window.location.search);
		var scrollHandle = qs.get("scroll");
		if (scrollHandle) {
			var row = table.getRow(scrollHandle);
			if (row) {
				row.scrollTo("center", true);
			}
		}
	});
	*/

	document.getElementById('loading')!.style.display = 'none';
	document.getElementById('achtable')!.style.display = 'block';
}

main();
